import RadioGroup from '../radio/src/radio-group'

export default RadioGroup
